<template>
  <div>
    <v-dialog
      v-model="loginDialog"
      max-width="800"
      persistent
    >
      <v-card>
        <v-container
          class="fill-height"
          fluid
        >
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              cols="12"
              sm="6"
            >
              <div>
                <div class="headline font-weight-light">
                  Iniciar Sesión
                </div>

                <div class="subtitle-1 font-weight-light">
                  Inicia sesión en tu cuenta
                </div>

                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  class="py-4 text-center"
                >
                  <v-text-field
                    v-model="email"
                    label="Correo electrónico"
                    class="purple-input"
                    prepend-icon="mdi-email"
                    :rules="emailRules"
                    outlined
                  />

                  <v-text-field
                    v-model="pass"
                    label="Contraseña"
                    class="purple-input"
                    prepend-icon="mdi-lock"
                    :rules="passRules"
                    outlined
                    required
                    type="password"
                  />
                  <v-btn
                    color="blue darken-1"
                    @click="login"
                  >
                    Ingresar
                  </v-btn>
                  <p>
                    <restore />
                  </p>
                </v-form>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="text-center"
            >
              <div class="headline font-weight-light text-center">
                Regístrate
              </div>

              <p class="subtitle-1 font-weight-light text-center mt-3">
                Regístrate y accede a “Animales al rescate”.
              </p>

              <v-btn
                color="blue darken-1"
                @click="register"
              >
                ¡Regístrate Ahora!
              </v-btn>
              <v-col />
            </v-col>
          </v-row>
        </v-container>
        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="loginDialogSet"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <register-dialog
      :register-dialog="registerDialog"
      :login-dialog="loginDialog"
      @updateRegisterDialog="updateRegisterDialog"
      @updateLoginDialog="updateLoginDialog"
    />
  </div>
</template>

<script>
  import registerDialog from '@/views/dashboard/pages/auth/Register'
  import Restore from '@/views/dashboard/pages/auth/Restore'

  export default {
    components: {
      registerDialog,
      Restore,

    },
    props: {
      loginDialog: {
        type: Boolean,
      },
    },
    data () {
      return {
        registerDialog: false,
        valid: true,
        pass: null,
        email: null,
        passRules: [v => !!v || 'Contraseña es requerido'],
        emailRules: [
          value => !!value || 'correo electrónico es requerido.',
          value => (value || '').length <= 50 || 'Max 50 caracteres',
          value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'correo electrónico invalido.'
          },
        ],
      }
    },
    watch: {
      loginDialog (val) {
        this.$refs.form.reset()
      },
    },
    methods: {
      loginDialogSet () {
        this.$emit('updateLoginDialog', false)
      },
      login () {
        if (this.$refs.form.validate()) {
          const user = {
            email: this.email,
            pass: this.pass,
          }
          this.$store.commit('SET_LOADING', true)
          this.$emit('updateLoginDialog', false)
          this.$store.dispatch('SIGN_IN', user)
        } else {
          console.log('Faltan datos')
        }
      },
      register () {
        this.loginDialogSet()
        this.registerDialog = true
      },
      updateRegisterDialog (newData) {
        console.log(newData)
        this.registerDialog = newData
      },
      updateLoginDialog () {
        this.$emit('updateLoginDialog', true)
      },
    },
  }
</script>
